import React, { useCallback, useEffect, useRef, useState } from "react";
import { apiget, apipost } from '../../../service/API';
import { toast } from 'react-toastify';
import { scrollToTop } from "../../../service/ScrollToTop";
import Loader from "../Layout/Loader";
import Banner from "../../../components/home/home-without-login/Banner";
import SubCategoryByCategory from "../../../components/home/home-without-login/SubCategoryByCategory";
import Testimonials from "../../../components/home/Testimonial";
import FAQ from "../../../components/home/home-without-login/FAQ";
import ContactUs from "../../../components/home/home-without-login/ContactUs";
import API from "../../../API/apiCollection";

export default function Home() {
  // const [bannerLoader, setBannerLoader] = useState(false);
  // const [subCategoryByCategoryLoader, setSubCategoryByCategoryLoader] = useState(false);
  // const [testimonialsLoader, setTestimonialsLoader] = useState(false);
  // const [FAQLoader, setFAQLoader] = useState(false);
  const [getBanners, setGetBanners] = useState('');
  const hasFetchedBanners = useRef(false);
  const [getSubCategoriesByCategoryDetail, setGetSubCategoriesByCategoryDetail] = useState("");
  const [GetCategoryAndItemCount, setGetCategoryAndItemCount] = useState("");
  const hasFetchedSubCategoryByCategory = useRef(false);
  const hasFetchedGetTestimonial = useRef(false);
  const [testimonialDetails, setTestimonialDetails] = useState("");
  const hasFetchedGetFAQ = useRef(false);
  const [faqDetails, setFaqDetails] = useState("");
  const hasFetchedscrollToTop = useRef(false);

  // Get Banner API
  const getBanner = useCallback(async () => {
    try {
      const getBannerResult = await API.Banner.get_banner();
      // Get Banner Successfully
      if (getBannerResult && getBannerResult.data.status === true) {
        setGetBanners(getBannerResult.data.data);
      }
    } catch (error) {
      console.error(`Error while getting banner: ${error}`);
    }
  }, []);

  useEffect(() => {
    if (!hasFetchedBanners.current) {
      getBanner();
      hasFetchedBanners.current = true;
    }
  }, []);

  // Get Sub Category By Category
  const subCategoryByCategory = useCallback(async (categories) => {
    try {
      const getSubCategoriesResult = await API.Category.get_sub_category_by_category(categories);
      
      setGetSubCategoriesByCategoryDetail(getSubCategoriesResult);
    } catch (error) {
      console.error(`Error while fetching sub category: ${error}`);
    }
  }, []);

  // Get Category
  const getCategory = useCallback(async () => {
    try {
      const getCategoryResult = await API.Category.get_category();
      // Get Category Successfully
      if (getCategoryResult?.data?.status === true) {
        setGetCategoryAndItemCount(getCategoryResult.data);
        subCategoryByCategory(getCategoryResult.data);
      }
    } catch (error) {
      console.error(`Error while getting category: ${error}`);
    }
  }, []);

  useEffect(() => {
    if (!hasFetchedSubCategoryByCategory.current) {
      getCategory();
      hasFetchedSubCategoryByCategory.current = true;
    }
  }, [getCategory]);

  // Get Testimonial API
  const getTestimonial = useCallback(async () => {
    try {
      const getTestimonialResult = await API.Testimonial.get_testimonial();
      // Get Testimonial Successfully
      if (getTestimonialResult && getTestimonialResult.data.status === true) {
        setTestimonialDetails(getTestimonialResult.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (!hasFetchedGetTestimonial.current) {
      getTestimonial();
      hasFetchedGetTestimonial.current = true;
    }
  }, [getTestimonial]);


  useEffect(() => {
    if (!hasFetchedscrollToTop.current) {
      scrollToTop();
      hasFetchedscrollToTop.current = true;
    }
  }, []);

  // Get FAQ API
  const getFAQ = useCallback(async () => {
    try {
      const getFaqResult = await API.FAQ.get_faq();
      // Get FAQ Successfully
      if (getFaqResult?.data?.status === true) {
        setFaqDetails(getFaqResult.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (!hasFetchedGetFAQ.current) {
      getFAQ();
      hasFetchedGetFAQ.current = true;
    }
  }, [getFAQ]);

  return (
    <React.Fragment>
      {/* {getBanners && getSubCategoriesByCategoryDetail && testimonialDetails && faqDetails ? ( */}
        <React.Fragment>
          <Banner getBanner={getBanners}/>
          <SubCategoryByCategory getSubCategoriesByCategoryDetail={getSubCategoriesByCategoryDetail} GetCategoryAndItemCount={GetCategoryAndItemCount} />
          <Testimonials testimonialDetails={testimonialDetails} />
          <FAQ faqDetails={faqDetails} />
          <ContactUs />
        </React.Fragment>
      {/* ) : (
        <Loader />
      )} */}
    </React.Fragment>
  );
}
